module.exports = __webpack_public_path__ + "static/img/leisure.3b3f51b2.png";